import React from "react";

export const Navigation = (props) => {
  const closeMenu = () => {
    // Find the navbar-collapse and collapse it when an item is clicked
    const navbar = document.getElementById("bs-example-navbar-collapse-1");
    if (navbar.classList.contains("in")) {
      navbar.classList.remove("in");
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Pienremppaamo
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#aboutz" className="page-scroll" onClick={closeMenu}>
                Meistä
              </a>
            </li>
            <li>
              <a href="#srv" className="page-scroll" onClick={closeMenu}>
                Palvelut
              </a>
            </li>
            <li>
              <a href="#prices" className="page-scroll" onClick={closeMenu}>
                Hinnasto
              </a>
            </li>
            <li>
              <a href="#values" className="page-scroll" onClick={closeMenu}>
                Arvot
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeMenu}>
                Ota yhteyttä
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
